import { useState, useEffect, useRef } from "react";
import { Link } from "react-router-dom";
import { Button, Modal, ModalBody, ModalHeader } from "reactstrap";
import "../layout/layout.css";
import "./preview.css";
import React from "react";
import _ from "lodash";
import { Accordion, ModalTitle } from "react-bootstrap";
import "/node_modules/react-grid-layout/css/styles.css";
import "/node_modules/react-resizable/css/styles.css";
import httpService from "../../../services/http.service";
import { useHistory } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import Loader from "../../common/loader";
import { faQuestionCircle, faTrash } from "@fortawesome/free-solid-svg-icons";
import LayoutSelection from "../../../layoutselection";
import Layout from "../layout/layout";
import "react-toastify/dist/ReactToastify.css";
import LayoutSelectionEdit from "../../../layoutselectionEdit";
import SuccessMessage from "../../common/successMsg";
import ErrorMessage from "../../common/errorMsg";
import ImportMediaDialog from "../../setting/ManageMedia/importMediaFolder/importMediaDialog";
import useUserSubscription from "../../common/userSubcriptionHook";

let Preview = (props) => {
  const history = useHistory();
  const ref = useRef(null);
  let BucketUser = localStorage.getItem('UserId')
  const [modaladdLayout, setmodaladdLayout] = useState(false);
  const [modaleditLayout, setmodaleditLayout] = useState(false);
  const [loading, setLoading] = useState(false);
  const [modaleditLayoutProp, setmodaleditLayoutProp] = useState(false);
  const [modaleditLayoutPropPass, setmodaleditLayoutPropPass] = useState(false);
  const [modaleditLayoutConfirm, setmodaleditLayoutConfirm] = useState(false);
  const [LayoutIDModel, setLayoutIDModel] = useState("");
  const [LayoutIDModelCheck, setLayoutIDModelCheck] = useState(false);
  const [LayoutIDName, setLayoutIDName] = useState("");
  const [layoutnameprop, setlayoutnameprop] = useState("");
  const [layoutidprop, setlayoutidprop] = useState("");
  const [layoutpropertyprop, setlayoutpropertyprop] = useState({});
  const [layoutpropertyidprop, setlayoutpropertyidprop] = useState({});
  const [layoutName, setLayoutName] = useState(false);
  const [editLname, setEditLname] = useState("");
  const [borderWidthProp, setborderWidthProp] = useState(5);
  const [borderColorProp, setborderColorProp] = useState("#000");
  const [addwidgetDelete, setaddwidgetDelete] = useState([]);
  const [LayoutDataObject, setLayoutDataObject] = useState({});
  const [layoutidTrue, setlayoutidTrue] = useState("");
  const [layoutLocalReplicate, setlayoutLocalReplicate] = useState("");
  const [replicateData, setReplicateData] = useState("");
  const [replicateProperty, setReplicateProperty] = useState('')
  const [allProperty, setAllProperty] = useState([])

  const [modalImportopen, setModalImportOpen] = useState(false);
  const [uploadingLoader, setUploadingLoader] = useState(false);
  const { user, checkActiveStatus } = useUserSubscription();


  const [naslicence, setNaslicence] = useState(false)


  function isCurrentDateBetween(startDate, endDate) {
    const currentDate = new Date(); // Get the current date

    // Convert input dates to Date objects if they aren't already
    const start = new Date(startDate);
    const end = new Date(endDate);

    // Check if the current date is between or equal to the start and end dates
    if (currentDate >= start && currentDate <= end) {

      return true;
    } else {


      return false;
    }
  }
  useEffect(() => {
    if (user) {
      checkActiveStatus()
    }
  }, [user, checkActiveStatus])

  
  async function getUsersNASInfo() {
    try {
      const res = await httpService.get(`/check-gcp-storage?userId=${BucketUser}`);
      if (res.data) {
        if (res.data.user.nasSpace > 0) {
          if (isCurrentDateBetween(res.data.user.startDateNas, res.data.user.endDateNas)) {
            setNaslicence(false)
          } else {
            setNaslicence(true)
          }
        } else {
          setNaslicence(true)

        }
      }
    } catch (err) {
      console.log({ err });
    }
  }
  useEffect(() => {
    getUsersNASInfo();
  }, [])

  const toggleModal = () => {
    setModalImportOpen(!modalImportopen);
  };

  const openImportfiles = () => {
    setModalImportOpen(true);
  };




  useEffect(() => {
    if (!props.verifyTokenUser && history.location.pathname != '/login') history.push('/login')
  }, [props.verifyTokenUser])

  useEffect(() => {
    setLoading(true);
    let string = window.location.href.split("/content/").length > 1
      ? window.location.href.split("/content/")[1].split("/")[0]
      : ""
    setlayoutidTrue(string);
    setLoading(false);
  }, [])

  const editLayoutN = async () => {
    let dataPost = {
      id: LayoutIDModel,
      name: editLname,
    };
    let data = await httpService
      .CreateUpdate("updateSelectedLayoutName", dataPost)
      .catch((err) => {
        return;
      });
    if (data) {
      SuccessMessage("Layout name updated successfully")
      setLayoutIDName(editLname);
      layoutData();
    }
  };

  const toggleLayoutName = async () => {
    setLayoutName((prevState) => !prevState);
  };
  const toggleAddLayout = () => setmodaladdLayout((prevState) => !prevState);
  const toggleeditLayoutProp = () => setmodaleditLayoutProp((prevState) => !prevState);
  const toggleeditLayoutPropPass = (name) => {
    if (!modaleditLayoutPropPass) {
      setlayoutLocalReplicate(name + " - Copy");
    }
    setReplicateProperty('')
    setmodaleditLayoutPropPass((prevState) => !prevState)
  }

  const toggleEditConfirm = () =>
    setmodaleditLayoutConfirm((prevState) => !prevState);
  const toggleeditLayout = () => {
    setLoading(true);
    if (modaleditLayout) {
      toggleEditConfirm();
    } else {
      setmodaleditLayout(!modaleditLayout);
      layoutData();
    }
    setLoading(false);
  };
  const [widgetLoading, setwidgetLoading] = useState(false);
  const [layoutArray, setlayoutArray] = useState([]);
  const [widthLayout, setwidthLayout] = useState(0);
  let dataUserPost = { userID: localStorage.getItem("UserId") };

  useEffect(() => {
    if (ref && ref.current && ref.current.offsetWidth) {
      setwidthLayout(parseInt(ref.current.offsetWidth));
    }
  }, [modaleditLayout, widgetLoading, ref, widthLayout, layoutArray]);

  useEffect(() => {
    if (ref && ref.current && ref.current.offsetWidth) {
      setwidthLayout(parseInt(ref.current.offsetWidth));
    }
  });

  useEffect(async () => {
    let allProperty = await httpService.CreateUpdate("getallProperty", { UserId: JSON.stringify(dataUserPost.userID) })
      .catch((err) => {


        if (err && err.response && err.response.status == 401 && localStorage.getItem("UserId")) {
          ErrorMessage("Session expired, please login again")
        }
        history.push("/")
        localStorage.clear()
        return;
      });
    if (allProperty) setAllProperty(allProperty.data)
    layoutData();
  }, []);

  const layoutData = async () => {
    setLoading(true);
    let LayoutArraydata = await httpService
      .CreateUpdate("getSelectedLayout", dataUserPost)
      .catch((err) => {
        return;
      });
    setlayoutArray(LayoutArraydata?.data?.data);
    let dataLayouts = LayoutArraydata?.data?.data;
    let dataObject = {};
    for (let i = 0; i < dataLayouts.length; i++) {
      if (dataLayouts[i].propertyData && dataLayouts[i].propertyData.length > 0) {
        for (let j = 0; j < dataLayouts[i].propertyData.length; j++) {
          if (dataObject[`${dataLayouts[i].propertyData[j].label}`]) {
            dataObject[`${dataLayouts[i].propertyData[j].label}`].push(
              dataLayouts[i]
            );
          } else {
            dataObject[`${dataLayouts[i].propertyData[j].label}`] = [
              dataLayouts[i],
            ];
          }
        }
      } else {
        if (dataObject[`Unassigned Property`]) {
          dataObject[`Unassigned Property`].push(dataLayouts[i]);
        } else {
          dataObject[`Unassigned Property`] = [dataLayouts[i]];
        }
      }
    }
    setLayoutDataObject(dataObject);
    setwidgetLoading(true);
    setLoading(false);
  };

  const ProceedToReplicateLayout = async () => {
    if (!layoutLocalReplicate) {
      ErrorMessage('Please enter a Name !')
      return;
    }
    if (!replicateProperty) {
      ErrorMessage('Please select a property !')
      return;
    }
    let x = allProperty.filter((ele) => ele._id === replicateProperty)
    let array = []
    array.push({ value: replicateProperty, label: x[0].Name, PropertyId: replicateProperty })
    let data = {
      layoutId: replicateData._id,
      selectedLayout: replicateData.selectedLayout,
      name: layoutLocalReplicate,
      propertyData: array,
      userID: replicateData.userID
    };
    const Layout = await httpService
      .CreateUpdate("saveSelectedLayout", data)
      .catch((err) => {
        console.log(err);
      });
    SuccessMessage("Layout added successfully")
    let LayoutArraydata = await httpService
      .CreateUpdate("getSelectedLayout", dataUserPost)
      .catch((err) => {
        if (err && err.response && err.response.status == 401 && localStorage.getItem("UserId")) {
          ErrorMessage("Session expired, please login again")
        }
        return;
      });
    setlayoutArray(LayoutArraydata.data.data);
    layoutData();
    setlayoutLocalReplicate("");
    setmodaleditLayoutPropPass(false);
  };

  const layoutarrayretrieve = async () => {
    let LayoutArraydata = await httpService
      .CreateUpdate("getSelectedLayout", dataUserPost)
      .catch((err) => {
        if (err && err.response && err.response.status == 401 && localStorage.getItem("UserId")) {
          ErrorMessage("Session expired, please login again")
        }
        return;
      });
    setlayoutArray(LayoutArraydata.data.data);
  };

  const removeLayout = async (layout_id) => {
    let res = window.confirm('Do you want to delete this Layout ?')
    if (!res) { return; }
    let dataPost = {
      layout_id: layout_id,
    };
    let widgetdata = await httpService
      .CreateUpdate("removelayoutAPI", dataPost)
      .catch((err) => {
        return;
      });
    let LayoutArraydata = await httpService
      .CreateUpdate("getSelectedLayout", dataUserPost)
      .catch((err) => {
        if (err && err.response && err.response.status == 401 && localStorage.getItem("UserId")) {
          ErrorMessage("Session expired, please login again")
        }
        return;
      });
    SuccessMessage("Layout removed ")
    setlayoutArray(LayoutArraydata.data.data);
    layoutData();
  };

  const layoutExists = (name, arr) => {
    return arr.some(function (el) {
      return el.value === name;
    });
  }

  const replicateLayout = async (item) => {
    setReplicateData(item)
    toggleeditLayoutPropPass(item.name);
  }

  useEffect(()=>{
    const customerID = localStorage.getItem("customerId");
    const type = localStorage.getItem("CloudUserType");
    if (customerID === 'Admin' || type === "admin") {
      history.push("/admindashboard");
    }
  },[])

  return (
    <div className="mainlayout row">
      {props.showProperty ? (
        // new design ---
        <div
          className="othercomponentnavbar"
          style={{}}
        >
          {loading ? <Loader /> : null}
          <div className="form-boxdiv ">
            <div className="" style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              padding: 9
            }}>
              <div className="" style={{ display: "flex", gap: "10px", alignItems: "center" }}>
                <div
                  onClick={() => {
                    history.push("/clouddashboard");
                  }}
                >
                  <Button className="back-btn"><i class="fa fa-chevron-left" aria-hidden="true"></i></Button>
                </div>
                <b>LAYOUTS {"  "} </b>

              </div>
              <div className="">
                <Button disabled={naslicence} className="btn-sm  btn btn-primary" onClick={openImportfiles}>

                  <div style={{ color: "white" }}>Upload Assets Files From Cloud Storage</div>

                </Button>

                <Button className="btn-sm  btn btn-primary" >

                  <div onClick={toggleAddLayout} style={{ color: "white" }}>Add Layout</div>

                </Button>
              </div>
            </div>
            <div
              className="m-3" style={{ border: "1px solid #dee2e6" }}
            >
              <div className="row layoutHead dasboardTH">
                <div className="col-2">
                  <b>Layout Name</b>
                </div>
                <div className="col-2">
                  <b>Replicate Layout </b>
                </div>
                <div className="col-2">
                  <b> Edit Layout </b>
                </div>
                <div className="col-2 ">
                  <b>Select Layout</b>
                </div>
                <div className="col-2">
                  <b>View Layout</b>
                </div>

                <div className="col-2 ">
                  <b>Delete Layout</b>
                </div>
              </div>
              {layoutArray.map((e, i) => {
                return (
                  <div>
                    {layoutExists(layoutidTrue, e.propertyData) ? (
                      <div className="row datarows">
                        <div className="col-2 " style={{ cursor: "pointer" }} onClick={() => {
                          toggleeditLayoutProp();
                          setlayoutnameprop(e.name);
                          setlayoutpropertyprop(e.propertyData);
                          setlayoutpropertyidprop(e.PropertyId);
                          setlayoutidprop(e._id);
                        }}>
                          {e.name != undefined && e.name != "" ? (
                            <div>{e.name}</div>
                          ) : (
                            <div>Layout</div>
                          )}
                        </div>
                        <div className="col-2">
                          <span
                            style={{ cursor: "pointer" }}
                            onClick={() => replicateLayout(e)}
                          >Copy</span>
                        </div>
                        <div className="col-2">
                          <Button
                            className="btn btn-sm btn-secondary"
                            onClick={() => {
                              setLayoutIDModel(e._id);
                              setLayoutIDName(e.name);
                              setEditLname(e.name);
                              e.color
                                ? setborderColorProp(e.color)
                                : setborderColorProp("#000");
                              e.width
                                ? setborderWidthProp(e.width)
                                : setborderWidthProp("3");
                              setLayoutIDModelCheck(e.checked);
                              toggleeditLayout();
                            }}
                            color="lik"
                            style={{ transform: "scale(1.2)" }}
                          >
                            {/* <i className="edit outline icon"></i> */}
                            <i class="edit icon me-0"></i>
                          </Button>{" "}
                          { }
                        </div>
                        {/* select layout */}
                        <div
                          className="col-2"
                          style={{ paddingTop: "4px" }}
                        >
                          <input
                            type="checkbox"
                            className="checkboxLayout"
                            value={e._id}
                            checked={e === 'Unassigned Property' ? false : e.checked}
                            onChange={async (event) => {
                              if (e !== 'Unassigned Property') {
                                setLayoutIDModelCheck(!e.checked);
                                let dataPost = {
                                  id: e._id,
                                  checked: !e.checked,
                                };
                                await httpService.CreateUpdate("updateSelectedLayout", dataPost)
                                  .catch((err) => {
                                    return;
                                  });
                                layoutData();
                              }
                            }}
                          ></input>
                        </div>
                        <div className="col-2" style={{}}>
                          <Link
                            target="_blank"
                            rel="noopener noreferrer"
                            to={`/view/${e._id}`}
                          >
                            View
                          </Link>
                        </div>
                        <div className="col-2 ">
                          <Button
                            className="btn btn-danger"
                            color="danger"
                            onClick={() => removeLayout(e._id)}
                          // style={{ transform: "scale(0.7)" }}
                          >
                            {/* <FontAwesomeIcon
                                      className="icon"
                                      icon={faTrash}
                                      color="danger"
                                    /> */}
                            <i class="trash icon me-0"></i>

                          </Button>
                        </div>
                      </div>
                    ) : (
                      ""
                    )}
                  </div>
                );
              })}

              {/* ---- */}

            </div>
          </div>
        </div>
      ) : (
        <div className="mainClass mainClassLayouts">
          {loading ? <Loader /> : null}
          <div className="form-boxdiv ">
            <div className="row form-boxtopline5">
              <div className="col-9">
                <b>LAYOUTS {"  "} </b>
                <Button className="  btn btn-primary mt-1 addwidgetButton">
                  <b>
                    <div onClick={toggleAddLayout}> + Add Layout</div>
                  </b>
                </Button>
              </div>
              <div className="col-3 headerLayoutgoback">
                <div
                  onClick={() => {
                    history.push("/clouddashboard");
                  }}
                >
                  <Button color="primary">Go Back</Button>
                </div>
              </div>
            </div>
            <div className="custom-control custom-checkbox">
              <Accordion disabled defaultActiveKey="0" style={{ paddingBottom: "20px" }}>
                {Object.entries(LayoutDataObject).map((item, Layoutindex) => {
                  return (
                    <Accordion.Item eventKey={Layoutindex}>
                      <Accordion.Header>
                        <b>{item[0]}</b>
                      </Accordion.Header>
                      <Accordion.Body>
                        <div
                          style={{
                            margin: "0.7%",
                            padding: "10px",
                            border: "1.4px solid gray",
                          }}
                        >
                          <div className="row dataheading">
                            <div className="col-2 ">
                              <b>Layout Name</b>
                            </div>
                            <div className="col-2">
                              <b>Replicate Layout </b>
                            </div>
                            <div className="col-2 ">
                              <b> Edit Layout </b>
                            </div>
                            <div className="col-2 ">
                              <b>Select Layout</b>
                            </div>
                            <div className="col-2 ">
                              <b>View Layout</b>
                            </div>
                            <div className="col-2 ">
                              <b>Delete Layout</b>
                            </div>
                          </div>
                          {item[1].map((e, i) => {
                            return (
                              <div className="row datarows">
                                <div
                                  className="col-2"
                                  style={{ cursor: "pointer" }}
                                  onClick={() => {
                                    toggleeditLayoutProp();
                                    setlayoutnameprop(e.name);
                                    setlayoutpropertyprop(e.propertyData);
                                    setlayoutidprop(e._id);
                                  }}
                                >
                                  {e.name != undefined && e.name != "" ? (
                                    <span>{e.name}</span>
                                  ) : (
                                    <span>Layout</span>
                                  )}
                                </div>
                                <div className="col-2">
                                  <span
                                    style={{ paddingTop: "4px", cursor: "pointer" }}
                                    onClick={() => replicateLayout(e)}
                                  >Copy</span>
                                </div>
                                <div className="col-2">
                                  <Button
                                    onClick={() => {
                                      setLayoutIDModel(e._id);
                                      setLayoutIDName(e.name);
                                      setEditLname(e.name);
                                      e.color
                                        ? setborderColorProp(e.color)
                                        : setborderColorProp("#000");
                                      e.width
                                        ? setborderWidthProp(e.width)
                                        : setborderWidthProp("3");
                                      setLayoutIDModelCheck(e.checked);
                                      toggleeditLayout();
                                    }}
                                    color="lik"
                                    style={{ transform: "scale(1.2)" }}
                                  >
                                    <i className="edit outline icon"></i>
                                  </Button>{" "}
                                  { }
                                </div>
                                <div
                                  className="col-2"
                                  style={{ paddingTop: "4px" }}
                                >
                                  <input
                                    type="checkbox"
                                    className="checkboxLayout"
                                    value={e._id}
                                    checked={item[0] === 'Unassigned Property' ? false : e.checked}
                                    onChange={async (event) => {
                                      if (item[0] !== 'Unassigned Property') {
                                        setLayoutIDModelCheck(!e.checked);
                                        let dataPost = {
                                          id: e._id,
                                          checked: !e.checked,
                                        };
                                        await httpService.CreateUpdate("updateSelectedLayout", dataPost)
                                          .catch((err) => {
                                            return;
                                          });
                                        layoutData();
                                      }
                                    }}
                                  ></input>
                                </div>
                                <div
                                  className="col-2 "
                                  style={{ paddingTop: "4px" }}
                                >
                                  <Link
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    to={`/view/${e._id}`}
                                  >
                                    View
                                  </Link>
                                </div>
                                <div className="col-2 ">
                                  <Button
                                    color="danger"
                                    onClick={() => removeLayout(e._id)}
                                  // style={{ transform: "scale(0.7)" }}
                                  >
                                    {/* <FontAwesomeIcon
                                      className="icon"
                                      icon={faTrash}
                                      color="danger"
                                    /> */}
                                    <i className="icon me-0"></i>
                                  </Button>
                                </div>
                              </div>
                            );
                          })}
                        </div>
                      </Accordion.Body>
                    </Accordion.Item>
                  );
                })}
              </Accordion>
            </div>
          </div>
        </div>
      )}

      <Modal size="xl" isOpen={modaladdLayout} toggle={toggleAddLayout}>
        <ModalHeader toggle={toggleAddLayout}>Choose Layout</ModalHeader>
        <ModalBody>
          <div>
            <LayoutSelection
              setlayoutCheck={(p) => {
                toggleAddLayout();
                layoutarrayretrieve();
                layoutData();
              }}
              verifyTokenUser={props.verifyTokenUser}
              setVerifyTokenUser={props.setVerifyTokenUser}
            />
          </div>
        </ModalBody>
      </Modal>
      <Modal size="md" isOpen={modaleditLayoutProp} toggle={toggleeditLayoutProp}>
        <ModalHeader toggle={toggleeditLayoutProp}>Edit Layout</ModalHeader>
        <ModalBody>
          <div>
            <LayoutSelectionEdit
              setlayoutCheck={(p) => {
                toggleeditLayoutProp();
                layoutarrayretrieve();
                layoutData();
              }}
              layoutName={layoutnameprop}
              propertyData={layoutpropertyprop}
              id={layoutidprop}
              verifyTokenUser={props.verifyTokenUser}
              setVerifyTokenUser={props.setVerifyTokenUser}
            />
          </div>
        </ModalBody>
      </Modal>

      <Modal
        size="xl"
        isOpen={modaleditLayout}
        fullscreen
        toggle={toggleeditLayout}
        className="modaleditLayout"
        style={{ overflowY: "scroll" }}
      >
        <ModalHeader
          toggle={toggleeditLayout}
          style={{
            paddingRight: "10px",
            paddingLeft: "10px",
            fontWeight: "bold",
            fontSize: "large",
          }}
        >
          Layout( <b>{LayoutIDName}</b>)
          <Button
            onClick={() => {
              setLayoutName(true);
            }}
            color="lik"
            className="shadow-none"
          >
            {" "}
            <i className="edit outline icon editLayoutName"></i>
          </Button>
        </ModalHeader>
        <ModalBody>
          <div className="editLayoutModal">
            <Layout
              rightContentType={"layout"}
              selectedLayoutID={LayoutIDModel}
              borderColor={borderColorProp}
              borderWidth={borderWidthProp}
              preview={false}
              view={false}
              toggleeditLayout={toggleeditLayout}
              addwidgetDelete={addwidgetDelete}
              setaddwidgetDelete={setaddwidgetDelete}
              modaleditLayoutConfirm={modaleditLayoutConfirm}
              toggleEditConfirm={toggleEditConfirm}
              modaleditLayout={modaleditLayout}
              setmodaleditLayout={setmodaleditLayout}
              verifyTokenUser={props.verifyTokenUser}
              setVerifyTokenUser={props.setVerifyTokenUser}
            ></Layout>
          </div>
        </ModalBody>
      </Modal>
      <Modal isOpen={layoutName} toggle={toggleLayoutName}>
        <ModalHeader toggle={toggleLayoutName}>Edit Layout Name</ModalHeader>
        <ModalBody>
          <div>
            <form onSubmit={(e) => e.preventDefault()}>
              <div>
                <b>Layout Name</b>
                <b style={{ color: "red" }}></b>
                <input
                  type="text"
                  className="form-control layoutName"
                  value={editLname}
                  onChange={(e) => setEditLname(e.target.value)}
                ></input>
              </div>
              <Button
                color="primary"
                type="submit"
                className="form-control layoutName "
                onClick={() => {
                  toggleLayoutName();
                  editLayoutN();
                }}
              >
                Update
              </Button>{" "}
            </form>
          </div>
        </ModalBody>
      </Modal>

      <Modal size="md" isOpen={modaleditLayoutPropPass} toggle={() => toggleeditLayoutPropPass("")}>
        <ModalHeader toggle={() => toggleeditLayoutPropPass("")}>Replicate Layout</ModalHeader>
        <ModalBody>
          <div>
            <label style={{ marginTop: "0px" }}>
              <b>Enter the Replicated Layout Name </b>
              <b style={{ color: "red" }}>*</b>
            </label>
            <input
              style={{ marginTop: "10px" }}
              className="form-control"
              placeholder="Layout Name"
              value={layoutLocalReplicate}
              onChange={(e) => {
                setlayoutLocalReplicate(e.target.value);
              }}
            ></input>
            <select
              className="form-control mt-3"
              value={replicateProperty}
              name='replicateProperty'
              onChange={(e) => {
                setReplicateProperty(e.target.value)
              }}
            >
              <option value=''>Select Property</option>
              {allProperty && allProperty.length && allProperty.map((e) =>
                e.UserId === replicateData.userID && <option value={e._id}>{e.Name}</option>
              )}
            </select>
            <div className="row">
              <Button
                color="primary"
                onClick={() => ProceedToReplicateLayout()}
                className="ButtonProceed"
              >
                Proceed
              </Button>
            </div>
          </div>
        </ModalBody>
      </Modal>
      <Modal
        isOpen={modalImportopen}
        toggle={uploadingLoader ? null : toggleModal}
      >
        <ModalHeader
          toggle={uploadingLoader ? null : toggleModal}
        >
          <ModalTitle>
            <strong>Import Files</strong>
          </ModalTitle>
        </ModalHeader>
        <ModalBody>
          <ImportMediaDialog
            onClose={toggleModal}
            // setShowPicker={setShowPicker}
            setUploadingLoader={setUploadingLoader}
          />
        </ModalBody>
      </Modal>
    </div>
  );
};

export default Preview;
